module.exports = __webpack_public_path__ + "img/clinics_mens.98ff9f92.jpg";